import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_47: FaireProductEntity = {
  token: "catalog_prod_prod-47",
  type: "product",
  name: "Curved Base Table Lamp with Pleated Shade",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=400&h=400&fit=crop",
  priceDollars: 67.83,
  msrpDollars: 169.58,
  sku: "JA0047",
  caseSize: 3,
  material: "Wood",
  collectionToken: "col_japandi",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 115,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_coffee-tea"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
